import _ from 'lodash';
import Service from './abstract';
import { ACCOUNTS_REPORT } from '../constants/accounts/donwload';

const defaultWith = 'type,status';
const defaultOptionsFind = {
    order: 'created_at-DESC',
    with: defaultWith
};

const defaultAccountsOptionsFind = {
    ...defaultOptionsFind,
    with: defaultWith +
     ',wallet,attributes,attributes.attribute,product,product.type,product.attributes,product.attributes.attribute,currency,currency.attributes,currency.attributes.attribute'
};

class Reports extends Service {
    constructor () {
        super('reports');
    }

    get defaultOptionsFind () {
        return _.merge({}, super.defaultOptionsFind, defaultOptionsFind);
    }

    createReport (data = {}, qs) {
        return this.post({
            url: `${this.basePath}/reports`,
            data,
            qs: _.defaultsDeep({}, qs),
        });
    }

    getReportURL (id) {
        return this.get({
            url: `${this.basePath}/reports/${id}/download`
        });
    }

    getOne (id) {
        return this.get({
            url: `${this.basePath}/reports/${id}`
        });
    }

    getReports (options) {
        let sentOptions = options;
        if (options.idType === ACCOUNTS_REPORT.id_type) sentOptions = defaultAccountsOptionsFind;
        return this.get({
            url: `${this.basePath}/reports`,
            qs: _.defaultsDeep({}, sentOptions)
        });
    }

    getReportsJournalEntries (options = {}) {
        const qs = {
            date: options.date,
            order: 'desc',
            paginationActive: true,
        };
        if (options.page) qs.page = options.page;
        if (options.pageSize) qs.pageSize = options.pageSize;

        return this.get({
            url: `${this.basePath}/reports/natura/accountingEntries`,
            qs
        });
    }

    downloadJournalEntries (options = {}) {
        return this.get({
            url: `${this.basePath}/reports/natura/accountingEntries`,
            qs: {
                date: options.date,
                download: true,
            },
            responseType: 'arraybuffer',
        });
    }

    saveSircupaFile (formData) {
        return this.post({
            url: `${this.basePath}/reports/natura/sircupa/uploadRegister`,
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }
}

export default new Reports();
